
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

interface ListType {
  id: string | number
  text: string
  disabled?: boolean
  name?: string
  isuse?: number
  desc?: string
}

@Component({})
export default class CheckBox extends Vue {
  checkList: string[] = []
  checked = false
  listData?: ListType[] = []

  @Prop() data?: ListType[]

  @Prop({ type: Boolean, default: true }) multiple?: boolean

  @Prop() maxsize?: any

  @Watch('data')
  watchValue() {
    this.checkList = []
    this.listData = this.data
  }

  handleDisable() {
    if (this.checkList && this.checkList.length >= this.maxsize) {
      if (this.listData) {
        this.listData = this.listData.filter(item => {
          if (!this.checkList.includes(item.id.toString())) {
            item.disabled = true
          }
          return item
        })
      }
    } else {
      if (this.listData) {
        this.listData = this.listData.filter(item => {
          item.disabled = false
          return item
        })
      }
    }
  }

  handleChange() {
    this.handleDisable()
    this.$emit(
      'input',
      this.listData && this.listData.length ? this.checkList : this.checked
    )
  }

  mounted() {
    if (this.data) {
      this.listData = this.data
    }
  }
}
